export const ServiceRoutes: Record<string, string> = {
  savings: '/accounts/savings',
  spending: '/accounts/spending',
  spending_dashboard: '/accounts/spending/dashboard',
  find_money: '/find-money',
  notifications: '/notifications',
  loan_application: '/accounts/loans',
  loan_dashboard: '/accounts/loans/dashboard',
  lender_alternatives: '/lender-alternatives',
  lender_alternatives_intro: '/lender-alternatives',
  credit: '/credit',
  credit_dashboard: '/credit/dashboard',
  credit_setup: '/credit-setup/creation',
  mpap: '/mpap',
  helping_hands: '/helping-hands',
  helping_hands_consents: '/helping-hands/consents',
  external: '/accounts/external',
  contest: '/pls',
  survey: '/survey',
  survey_info_view: '/survey/info-view',
  survey_emoney: 'survey/money_emergency_survey',
  web: '/web', // fallback
  chat_history: '/chathistory',
  my_spending: '/financialsnapshot',
  my_spending_web: '/my-spending',
  my_spending_info_view: '/my-spending/info-view',
  cash_advance: '/accounts/spending/cash-advance/intro',
  cash_advance_dashboard: '/accounts/spending/cash-advance/dashboard',
  cash_advance_info_view: '/accounts/spending/cash-advance/info-view',
  campaigns: 'campaigns',
  hardship_application: '/hardship'
};
